import React, { useEffect, useRef, useState } from 'react'
import MovieAndOTTNewsTable from '../../Movie/MovieAndOttNewsTable'
import TextAreaMovieAndOttNews from '../../Movie/TextAreaMovieAndOttNews'
import { Auth } from 'aws-amplify'
import { GetCurrentDate, getCurrentTimeUnixTimestamp } from '../../Movie/formatTodayDate'
import '../../Movie/movies.css'
import Updateperson from '../../../Services/Mutations/Updateperson'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'
import GetUserPermissions from '../../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../../Constants/Permissions'
// import { toast } from 'react-toastify'
// import { ToastStyle } from '../../Data/MovieStaticData'

function PersonUpdates(props) {
  const {
    activeSection,
    section,
    handleSectionClick,
    inputData,
    movieData,
    // DeleteOttAndNewsPermission,
    // ApproveOttAndNewsPermission,
    sendinputdata,
  } = props
  const [movieAndOttNews, setMovieAndOttNews] = useState('')
  const [movieAndOttNewste, setMovieAndOttNewste] = useState('')
  const [editIndex, setEditIndex] = useState(null)
  const inputReferencedescriptionEn = useRef(null)
  const inputReferencedescriptionTe = useRef(null)
  const [link, setLink] = useState('')
  const [DeleteOttAndNewsPermission, setDeleteOttNewsPermission] = useState(false)
  const [ApproveOttAndNewsPermission, setApproveOttNewsPermission] = useState(false)
  // const [showAllItems, setShowAllItems] = useState(false)

  const tableHeaders = [
    'status',
    // 'moderatorHandle',
    'description_En',
    'description_Te',
  ]

  const loggedInUserEmail = Auth.user.attributes?.email || ''
  const loggedInUserHandle = loggedInUserEmail ? `@${loggedInUserEmail.split('@')[0]}` : ''

  const updateData = async updates => {
    const updatedData = { ...inputData, ...updates }
    // Remove the field '__typename' from each object in the 'movieAndOTTNewsUpdates' array
    const updatedMovieAndOTTNewsUpdates = updatedData.personNewsUpdates.map(item => {
      // Create a copy of the object without the field '__typename'
      const { __typename, ...updatedItem } = item
      return updatedItem
    })

    sendinputdata(updatedData)
    const input = {
      PK: movieData.PK,
      SK: movieData.SK,
      // movieID: movieData.movieID,
      // contentType: inputData.contentType,
      personNewsUpdates: updatedMovieAndOTTNewsUpdates,
      moderatorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
      // tags: [...tags, tag.tagURL],
    }
    try {
      const upadatelog = await Updateperson(input)
      if (upadatelog.statusCode === 'A002') {
        // setAddedTag(true)
        return upadatelog
      }
    } catch (error) {
      console.warn(error)
    }
    //  const update = await UpdateMovie(input)
    //   if (update.statusCode === 'A001') {
    //     toast.success(update.statusMessage, ToastStyle)
    // }
    // sendBooleanValueChangeDone('movieAndOTTNewsUpdates', true)
  }

  const sendOttToArray = () => {
    updateData({
      personNewsUpdates: [
        {
          status: 'draft',
          moderatorID: Auth.user.username,
          moderatorHandle: loggedInUserHandle,
          description_En: movieAndOttNews,
          description_Te: movieAndOttNewste,
        },
        ...inputData.personNewsUpdates,
      ],
    })
    // sendBooleanValueChangeDone('movieAndOTTNewsUpdates', true)
    setMovieAndOttNews('')
    setMovieAndOttNewste('')
  }

  const deleteFunction = index => {
    updateData({
      personNewsUpdates: inputData.personNewsUpdates.filter((_, i) => i !== index),
    })
  }

  const approveFunction = index => {
    updateData({
      personNewsUpdates: inputData.personNewsUpdates.map((item, i) => {
        if (i === index && item.status === 'draft') {
          return {
            ...item,
            moderatorID: Auth.user.username,
            moderatorHandle: loggedInUserHandle,
            status: 'published',
            publishedDate: GetCurrentDate(),
            publishedTime: getCurrentTimeUnixTimestamp(),
          }
        }

        return item
      }),
    })
  }

  const editFunction = index => {
    const itemToEdit = inputData.personNewsUpdates[index]
    setEditIndex(index)

    setMovieAndOttNews(itemToEdit.description_En)
    setMovieAndOttNewste(itemToEdit.description_Te)
  }

  const saveEdit = () => {
    updateData({
      personNewsUpdates: inputData.personNewsUpdates.map((item, index) => {
        if (index === editIndex) {
          return {
            ...item,
            moderatorID: Auth.user.username,
            moderatorHandle: loggedInUserHandle,
            description_En: movieAndOttNews,
            description_Te: movieAndOttNewste,
          }
        }

        // if (index === 0 && editIndex === 0) {
        //   return {
        //     ...item,
        //     moderatorID: Auth.user.username,
        //     moderatorHandle: loggedInUserHandle,
        //     description_En: movieAndOttNews,
        //     description_Te: movieAndOttNewste,
        //   }
        // }

        return item
      }),
    })
    setEditIndex(null)
    setMovieAndOttNews('')
    setMovieAndOttNewste('')
  }

  // const handleButtonClick = description => {
  //   // eslint-disable-next-line no-alert
  //   const link = window.prompt('Enter the link:')
  //   if (link !== null) {
  //     const textarea =
  //       description === 'description_En'
  //         ? inputReferencedescriptionEn.current
  //         : inputReferencedescriptionTe.current

  //     if (
  //       textarea.selectionStart !== undefined &&
  //       textarea.selectionEnd !== undefined
  //     ) {
  //       const start = textarea.selectionStart
  //       const end = textarea.selectionEnd

  //       const selectedText =
  //         description === 'description_En'
  //           ? movieAndOttNews.substring(start, end)
  //           : movieAndOttNewste.substring(start, end)
  //       let updatedText = ''
  //       if (selectedText) {
  //         updatedText =
  //           description === 'description_En'
  //             ? `${movieAndOttNews.substring(
  //                 0,
  //                 start,
  //               )}${`<a href='${link}'>`}${selectedText}${'</a>'}${movieAndOttNews.substring(
  //                 end,
  //               )}`
  //             : `${movieAndOttNewste.substring(
  //                 0,
  //                 start,
  //               )}${`<a href='${link}'>`}${selectedText}${'</a>'}${movieAndOttNewste.substring(
  //                 end,
  //               )}`
  //       }

  //       // else {
  //       //   updatedText = `${
  //       //     description === 'description_En'
  //       //       ? movieAndOttNews
  //       //       : movieAndOttNewste
  //       //   } ${`<a href='${link}'>`}${'</a>'}`
  //       // }
  //       if (updatedText) {
  //         (description === 'description_En'
  //           ? setMovieAndOttNews
  //           : setMovieAndOttNewste)(updatedText)
  //       }
  //     }
  //   }
  // }

  const renderActions = (item, index) => {
    const actions = []
    if (item.status === 'draft' && ApproveOttAndNewsPermission) {
      actions.push(
        <span
          key='approve'
          className='cursor-pointer actionIconStylemovie'
          data-toggle='tooltip'
          title='Approve'
          onClick={() => approveFunction(index)}
        >
          <i className='fa fa-upload' />
        </span>,
      )
    }

    if (item.status === 'draft' || DeleteOttAndNewsPermission) {
      actions.push(
        <span
          key='delete'
          className='cursor-pointer actionIconStylemovie'
          data-toggle='tooltip'
          title='Delete'
          onClick={() => deleteFunction(index)}
        >
          <i className='fa fa-trash' />
        </span>,
      )
    }

    actions.push(
      <span
        key='edit'
        className='cursor-pointer actionIconStylemovie'
        data-toggle='tooltip'
        title='Edit'
        onClick={() => editFunction(index)}
      >
        <i className='fa fa-edit' />
      </span>,
    )

    return actions
  }

  useEffect(() => {
    const getPermissions = async () => {
      // Fetch user permissions
      const permissionInput = {
        mobileNumber: Auth.user.attributes.phone_number,
      }
      const userPermissions = await GetUserPermissions(permissionInput)
      const permissions = []
      const permissionsArr = []

      // Extract permissions from userRolesAndPermissions
      if (userPermissions && userPermissions.userRolesAndPermissions) {
        userPermissions.userRolesAndPermissions.forEach(item => {
          permissions.push(...item.permissions)
        })

        permissions.forEach(permission => {
          permissionsArr.push(permission.name)
        })
      }

      // Check if the "DisplayApproveMovieOption" permission is present
      // const EDitApproveOption = permissionsArr.includes(DefinedPermissions.DisplayApproveMovieOption)
      // const editOttAndNews = permissionsArr.includes(DefinedPermissions.MovieAndOTTNewsEdit)
      const DeleteOttAndNews = permissionsArr.includes(DefinedPermissions.MovieAndOTTNewsDelete)
      const ApproveOttAndNews = permissionsArr.includes(DefinedPermissions.MovieAndOTTNewsApprove)
      // setEDitApproveOptionBoolean(EDitApproveOption)
      // setEditOttNewsPermission(editOttAndNews)
      setDeleteOttNewsPermission(DeleteOttAndNews)
      setApproveOttNewsPermission(ApproveOttAndNews)
    }

    getPermissions()
  }, [])

  return (
    <div
      id={section}
      className={`accordion-item ${
        activeSection === section || activeSection === 'all' ? 'active' : ''
      }`}
    >
      <h2 className='accordion-header' id='headingFour'>
        <button
          className='accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseFour'
          aria-expanded={activeSection === section || activeSection === 'all'}
          aria-controls='collapseFour'
          onClick={() => handleSectionClick(section)}
          style={{ color: 'white' }}
        >
          <span>PersonUpdates</span>
          {activeSection === section || activeSection === 'all' ? <FaCaretUp /> : <FaCaretDown />}
        </button>
      </h2>
      <div
        id='collapseFour'
        className={`accordion-collapse collapse ${
          activeSection === section || activeSection === 'all' ? 'show' : ''
        }`}
        aria-labelledby='headingFour'
        data-bs-parent='#accordion'
      >
        <div className='personNewsContainer'>
          <MovieAndOTTNewsTable
            inputData={inputData}
            tableHeaders={tableHeaders}
            editIndex={editIndex}
            renderActions={renderActions}
            movieAndOTTNewsUpdates={
              inputData && inputData.personNewsUpdates ? inputData.personNewsUpdates : []
            }
            type={'person'}
            // showAllItems={showAllItems}
          />
        </div>
        <TextAreaMovieAndOttNews
          inputReferencedescriptionEn={inputReferencedescriptionEn}
          inputReferencedescriptionTe={inputReferencedescriptionTe}
          movieAndOttNews={movieAndOttNews}
          movieAndOttNewste={movieAndOttNewste}
          setMovieAndOttNews={setMovieAndOttNews}
          setMovieAndOttNewste={setMovieAndOttNewste}
          // handleButtonClick={handleButtonClick}
          editIndex={editIndex}
          sendOttToArray={sendOttToArray}
          saveEdit={saveEdit}
          link={link}
          setLink={setLink}
        />
      </div>
    </div>
  )
}

export default PersonUpdates
